/* /assets/wsr-finance.js */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
  function pmt(rate, nper, pv) { return rate === 0 ? pv / nper : (pv * rate) / (1 - Math.pow(1 + rate, -nper)); }

  function init(root) {
    var priceEl = root.querySelector('#wsr-price');
    var btn = root.querySelector('#wsr-calc');
    var outAff = root.querySelector('#out-affirm');
    var outAp = root.querySelector('#out-afterpay');
    var outPP4 = root.querySelector('#out-pp4');
    var outPPM = root.querySelector('#out-ppm');
    if (!priceEl || !btn || !outAff || !outAp || !outPP4 || !outPPM) return;

    function calc() {
      var raw = (priceEl.value || '').toString().replace(/[^0-9.]/g, '');
      var pv = parseFloat(raw) || 0;
      if (pv <= 0) {
        outAff.textContent = '—'; outAp.textContent = '—';
        outPP4.textContent = '—'; outPPM.textContent = '—';
        return;
      }
      // Illustrative examples
      outAff.textContent = money(pmt(0.15 / 12, 12, pv)) + '/mo (est.)';
      var p4 = pv / 4;
      outAp.textContent = '4 × ' + money(p4) + ' (est.)';
      outPP4.textContent = '4 × ' + money(p4) + ' (est.)';
      outPPM.textContent = money(pmt(0.24 / 12, 24, pv)) + '/mo (est.)';
    }

    btn.addEventListener('click', calc);
    priceEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') calc(); });
  }

  ready(function () {
    document.querySelectorAll('.wsr-estimator').forEach(init);
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.wsr-estimator').forEach(init);
    });
  });
})();
